import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import SeasonsAdmin from "./admin/SeasonsAdmin";
import LocationsAdmin from "./admin/LocationsAdmin";
import ProductTypesAdmin from "./admin/ProductTypesAdmin";
import ProductsAdmin from "./admin/ProductsAdmin";
import TemplatesAdmin from "./admin/TemplatesAdmin";
import SettingsAdmin from "./admin/SettingsAdmin";

const SUB_TABS = [
  { key: "seasons", label: "Seasons", Component: SeasonsAdmin },
  { key: "locations", label: "Locations", Component: LocationsAdmin },
  { key: "productTypes", label: "Product Types", Component: ProductTypesAdmin },
  { key: "products", label: "Products & Pricing", Component: ProductsAdmin },
  { key: "templates", label: "Templates", Component: TemplatesAdmin },
  { key: "settings", label: "Settings", Component: SettingsAdmin },
];

export default function QbAdminPage() {
  const [tab, setTab] = useState("seasons");
  const Active = SUB_TABS.find((t) => t.key === tab)?.Component || (() => null);

  return (
    <Box>
      <Tabs
        value={tab}
        onChange={(_e, v) => setTab(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
      >
        {SUB_TABS.map((t) => (
          <Tab key={t.key} value={t.key} label={t.label} />
        ))}
      </Tabs>
      <Active />
    </Box>
  );
}
